// Mercapoli - Política de Cookies
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowLeft, Cookie } from 'lucide-react';
import { Button } from '../../components/ui/button';
import Footer from '../../components/Footer';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";

const PoliticaCookies = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Política de Cookies | Mercapoli</title>
        <meta name="description" content="Información sobre el uso de cookies en Mercapoli." />
      </Helmet>

      {/* Header */}
      <header className="border-b border-border">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img src={LOGO_URL} alt="Mercapoli" className="w-10 h-10" />
              <span className="font-heading text-xl font-bold">Mercapoli</span>
            </Link>
            <Link to="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Volver
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-12">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-brand-accent/20 flex items-center justify-center">
              <Cookie className="h-8 w-8 text-brand-accent" />
            </div>
            <h1 className="font-heading text-4xl font-bold mb-4">
              Política de Cookies
            </h1>
            <p className="text-sm text-muted-foreground">
              Última actualización: Enero 2026
            </p>
          </div>

          <div className="prose prose-lg dark:prose-invert mx-auto space-y-8">
            <section>
              <h2 className="font-heading text-xl font-bold mb-4">¿Qué son las Cookies?</h2>
              <p>
                Las cookies son pequeños archivos de texto que se almacenan en su dispositivo 
                cuando visita nuestra plataforma. Nos ayudan a mejorar su experiencia y 
                recordar sus preferencias.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">Cómo Utilizamos las Cookies</h2>
              <p>Mercapoli utiliza cookies para:</p>
              <ul className="list-disc list-inside space-y-2 mt-4">
                <li>Mejorar la experiencia de navegación</li>
                <li>Recordar sus preferencias (idioma, ubicación)</li>
                <li>Mantener su sesión activa</li>
                <li>Analizar el tráfico y uso de la plataforma</li>
                <li>Personalizar contenido relevante</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">Tipos de Cookies</h2>
              <div className="space-y-4">
                <div className="p-4 rounded-xl bg-card border border-border">
                  <h3 className="font-bold mb-2">Cookies Esenciales</h3>
                  <p className="text-muted-foreground text-sm">
                    Necesarias para el funcionamiento básico de la plataforma. No pueden desactivarse.
                  </p>
                </div>
                <div className="p-4 rounded-xl bg-card border border-border">
                  <h3 className="font-bold mb-2">Cookies de Rendimiento</h3>
                  <p className="text-muted-foreground text-sm">
                    Nos ayudan a entender cómo los usuarios interactúan con la plataforma.
                  </p>
                </div>
                <div className="p-4 rounded-xl bg-card border border-border">
                  <h3 className="font-bold mb-2">Cookies de Funcionalidad</h3>
                  <p className="text-muted-foreground text-sm">
                    Permiten recordar sus preferencias para una experiencia personalizada.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">Gestión de Cookies</h2>
              <p>
                Usted puede <strong>aceptar, rechazar o configurar</strong> el uso de cookies 
                desde su navegador. Tenga en cuenta que deshabilitar ciertas cookies puede 
                afectar la funcionalidad de la plataforma.
              </p>
              <p className="mt-4">
                Para gestionar cookies en los navegadores más comunes:
              </p>
              <ul className="list-disc list-inside space-y-2 mt-4 text-muted-foreground">
                <li>Chrome: Configuración → Privacidad y seguridad → Cookies</li>
                <li>Firefox: Opciones → Privacidad y seguridad</li>
                <li>Safari: Preferencias → Privacidad</li>
                <li>Edge: Configuración → Privacidad</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">Contacto</h2>
              <p>
                Para consultas sobre nuestra política de cookies:
                <br />
                <a href="mailto:soporte@mercapoli.com" className="text-brand-primary hover:underline">
                  soporte@mercapoli.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PoliticaCookies;
